const moment = require("moment");
const utils = require("Sources/utils/utils");

module.exports = class SubscriptionGuest
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.key = options.key;
    this.email = options["user-email"];
    this.validUntil = options["valid-until"];
    this.timestamp = options.timestamp;
  };

  set timestamp(date)
  {
    this._stamp = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  };

  get timestamp()
  {
    return utils.isMomentObject(this._stamp) ? this._stamp.format("DD-MM-YYYY") : null;
  };

  set validUntil(date)
  {
    this._validuntil = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  };

  get validUntil()
  {
    return utils.isMomentObject(this._validuntil) ? this._validuntil.format("DD-MM-YYYY") : null;
  };

};



// WEBPACK FOOTER //
// ./app/js/models/subscription-guest.js